import style from "./style.module.scss";
import { MAP } from "@/constants";

const EmptyResult = () => {
  return (
    <div className={style.emptyContainer}>
      <img src="/icon/zoom-cancel.svg" alt="zoom cancel" />
      <p className={style.title}>{MAP.NOT_FOUND}</p>
      <p className={style.subTitle}>{MAP.NO_MATCHING}</p>
    </div>
  );
};

export default EmptyResult;


